import React, { useState, useEffect } from 'react'
import { NoResultsFound, PageLoading } from "../../components/Loading"
import { RiskGrid } from "../../components/RiskGrid"
import { SummaryFilter } from "../../components/SummaryFilter"
import { NotificationManager } from 'react-notifications'
import { utils } from "../../FromElsewhere/utils"
import { Query, whitespace, WhitespaceAPI } from "../../helpers/whitespace"
import { riskFilter } from "../../helpers/riskFilter"
import { Button, Modal, Tab, Tabs } from "react-bootstrap"

// https://stuk.github.io/jszip/ You may use it under the MIT license or the GPLv3 license
import * as JSZip from "jszip";

// https://github.com/ManasMadan/pdf-actions#installation
// import { createPDF,pdfArrayToBlob, mergePDF } from "pdf-actions";

// https://github.com/nbesli/pdf-merger-js
// import * as PDFMerger from "pdf-merger-js";

import PDFMerger from 'pdf-merger-js/browser';

class UnzippedPDF {
	name = "";
	data: any = null;
}

export const VerticalCombiner = () => {
	const [loaded, setLoaded] = useState(true)
    const [risks, setRisks] = useState<any[]>([])
    // const [allRisks, setAllRisks] = useState<any[]>([])
	const [riskID, setRiskID] = useState("")
	const [umr, setUMR] = useState("")
	const [insured, setInsured] = useState("")
	const [myPopup, setMyPopup] = useState<boolean>(false)
	const [activeTabKey, setActiveTabKey] = useState("SignedRisks");
	const INTRO_MESSAGE = "Enter a UMR or part of the Insured Name to find the risk";
	const [introMessage,setIntroMessage] = useState( INTRO_MESSAGE );

	const doSummary = ( grail ) => {
        grail = grail.trim();
		if( !grail ) {
			setIntroMessage( INTRO_MESSAGE );
			return;
		}
        NotificationManager.success( grail ? `Fetching for ${grail}` : "Fetching first 60 risks");
        const payload: any = {};	// statuses : [ "Signed","Endorsement","EndorsementPending" ] };
        if( grail ) {
            if( utils.validUMR( grail ) ) {
                payload.umrSearch = grail;
            } else {
                payload.nameSearch = grail;
            }
        }
		setIntroMessage("");
        setRisks( [] );
        setLoaded( false );
        whitespace(Query.POST, '/api/summary', payload ).then(response => {
            console.log( "POST /api/summary complete");
            setRisks( riskFilter.groupRisksSummary( response.data ));
			setLoaded(true);
        });
    }

	// useEffect(() => {
    //     setRisks([])
    //     setLoaded(false)
    //     const payload: any = {};	// statuses : [ "Signed","Endorsement","EndorsementPending" ] };
    //     whitespace(Query.POST, '/api/summary', payload ).then(response => {
	// 		const grouped = riskFilter.groupRisksSummary( response.data );
    //         setRisks( riskFilter.groupRisksSummary( response.data ) );
    //         setLoaded(true);
    //     })
    // }, [])

	const pickRisk = ( risk ) => {
        const selectedID = ( activeTabKey == "SignedRisks" ) ? utils.rootIC( risk.id ) + "::SIGNED" : risk.id;
		WhitespaceAPI.get( `/api/risks/${selectedID}`).then( response => {
			if( response.data && response.data.control ) {
				console.log( response.data.control );
				setInsured( response.data.control.insuredName );
				setUMR( response.data.control.umr );
				popupSelectedRisk( selectedID );
			}
		});
    }

	const popupSelectedRisk = id => {
		if(!myPopup) setMyPopup(true)
		setRiskID( id );
	}

	const doInternal = () => {
		doDownloadAndCombine( `${umr} Combined Internal`, ["RiskDetails", "Information", "SecurityDetails", "SubscriptionAgreement", "FiscalAndRegulatory", "BrokerRemunerationAndDeductions"] );
	}
	const doClient = () => {
		doDownloadAndCombine( `${umr} Combined for Client`, ["RiskDetails", "Information", "SecurityDetails"] );
	}

	const doDownloadAndCombine = async ( outputFile, sections ) => {
		//const outputFile = "Combined";
		const payload = {
			hideLogo : false,
			includeUMRInHeader : true,
			includeSections : sections, // ["RiskDetails", "Information", "SecurityDetails"],
			alignToBottomOfHeadings: false,
			exportContract : true,
			exportCarrierTerms : true,
			includeButtonStampInFooter : true,
			appendPDFAttachments : [],
			prependPDFAttachments : []
		};
		const url = `/export/pdf/${riskID}`;
		const unzippedFiles: UnzippedPDF[] = [];
		NotificationManager.success( `Calling ${url} ...` );
		whitespace( Query.BLOB, url, payload ).then( async response => {
			try {
				let msg = "";
				if( !response.data ) {
					msg = "No response.data"
					NotificationManager.success( msg );
				} else {
					const merger = new PDFMerger();
					const z: Blob[] = [];
					await JSZip.loadAsync(response.data).then(async (zip) => {
						console.log(zip.files);
						const keys = Object.keys(zip.files);
						for (const f in keys) {
							const n =  await zip.file(keys[f])?.async("blob");
							if (n) {
								z.push(n);
							}
						}
						return z;
					}).then(async (blobarr) => {
						console.log(blobarr.length);
							for (const file of blobarr) {
								await merger.add(file);
							}
							await merger.save(outputFile); 
							NotificationManager.success( `Saved ${outputFile}.pdf` );
					});
				}
			} catch( err ) {
				console.log( err );
				NotificationManager.error( `Process failed. Is this a Verticalised Risk?`)
			}
		});
	}

	const MyPopup = () => {
		return (
			<Modal size="lg" show={myPopup} onHide={() => setMyPopup(false)}>
				<Modal.Header closeButton>
					<Modal.Title>Download Combined PDF</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div>UMR: {umr}</div>
					<div>Insured: {insured}</div>
					<div className='LightGray'>{riskID}</div>
					<div className='Above12'><Button onClick={doInternal}>Internal</Button> covers all sections of the MRC</div>
					<div className='Above12'><Button onClick={doClient}>For Client</Button> just the first three MRC sections</div>
				</Modal.Body>
				<Modal.Footer>
					<b>ALPHA Release</b> for testing only
				</Modal.Footer>
			</Modal>
		)
	}	

	return (
        <>
		<div><SummaryFilter onSearch={doSummary}></SummaryFilter></div>
		{introMessage && <div className='Above12 Below12 WarningText'>{introMessage}</div>}
		<Tabs activeKey={activeTabKey} onSelect={(event) => setActiveTabKey(event || "SignedRisks")}>
            <Tab eventKey="SignedRisks" title="Signed Risks" className='BorderedTab'>
				{!loaded && <PageLoading/>}
				{loaded && !risks.length && <div>No selected risks</div>}
				<div className={`Fadein-wrapper ${risks.length && 'load'}`}>
					{riskID && MyPopup()}
					<div className='Above12 Below12 WarningText'>This tab selects the signed version of the risk in all cases</div>
					<RiskGrid input={risks} pickFn={pickRisk} singleLine={true} />
				</div>
			</Tab>
			<Tab eventKey="AllRisks" title="All Risks" className='BorderedTab'>
				{!loaded && <PageLoading />}
				{loaded && !risks.length && <div>No selected risks</div>}
				<div className={`Fadein-wrapper ${risks.length && 'load'}`}>
					<div className='Above12 Below12 WarningText'>This tab lets you select any version of the risk</div>
					<RiskGrid input={risks} pickFn={pickRisk} />
				</div>
			</Tab>
		</Tabs>

        </>
    )
}

